// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function colorToString(color) {
  switch (color) {
    case "Red" :
        return "#FF9999";
    case "Blue" :
        return "#9999FF";
    case "Green" :
        return "#99FF99";
    case "Yellow" :
        return "#FFFF99";
    case "Purple" :
        return "#CC99CC";
    case "Orange" :
        return "#FFC966";
    case "Grey" :
        return "#D3D3D3";
    
  }
}

function colorToName(color) {
  switch (color) {
    case "Red" :
        return "Red";
    case "Blue" :
        return "Blue";
    case "Green" :
        return "Green";
    case "Yellow" :
        return "Yellow";
    case "Purple" :
        return "Purple";
    case "Orange" :
        return "Orange";
    case "Grey" :
        return "Grey";
    
  }
}

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function color(t) {
  return t.color;
}

function description(t) {
  return t.description;
}

function priority(t) {
  return t.priority;
}

function emptyState(param) {
  return {
          id: undefined,
          name: "",
          color: "Grey",
          description: undefined,
          priority: undefined
        };
}

function setName(t, name) {
  return {
          id: t.id,
          name: name,
          color: t.color,
          description: t.description,
          priority: t.priority
        };
}

function setDescription(t, description) {
  return {
          id: t.id,
          name: t.name,
          color: t.color,
          description: description,
          priority: t.priority
        };
}

function setPriority(t, priority) {
  return {
          id: t.id,
          name: t.name,
          color: t.color,
          description: t.description,
          priority: priority
        };
}

function setColor(t, color) {
  return {
          id: t.id,
          name: t.name,
          color: color,
          description: t.description,
          priority: t.priority
        };
}

function decodeColor(json) {
  var match = Json_decode.field("color", Json_decode.string, json);
  switch (match) {
    case "#9999FF" :
        return "Blue";
    case "#99FF99" :
        return "Green";
    case "#CC99CC" :
        return "Purple";
    case "#FF9999" :
        return "Red";
    case "#FFC966" :
        return "Orange";
    case "#FFFF99" :
        return "Yellow";
    default:
      return "Grey";
  }
}

function fromJson(json) {
  return {
          id: Json_decode.field("id", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          color: decodeColor(json),
          description: Json_decode.field("description", (function (param) {
                  return Json_decode.optional(Json_decode.string, param);
                }), json),
          priority: Json_decode.field("priority", (function (param) {
                  return Json_decode.optional(Json_decode.$$int, param);
                }), json)
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "color",
                    colorToString(t.color)
                  ],
                  tl: {
                    hd: [
                      "description",
                      Json_encode.nullable((function (prim) {
                              return prim;
                            }), t.description)
                    ],
                    tl: {
                      hd: [
                        "priority",
                        Json_encode.nullable((function (prim) {
                                return prim;
                              }), t.priority)
                      ],
                      tl: /* [] */0
                    }
                  }
                }
              }
            });
}

var allColors = {
  hd: "Red",
  tl: {
    hd: "Blue",
    tl: {
      hd: "Green",
      tl: {
        hd: "Yellow",
        tl: {
          hd: "Purple",
          tl: {
            hd: "Orange",
            tl: {
              hd: "Grey",
              tl: /* [] */0
            }
          }
        }
      }
    }
  }
};

exports.colorToString = colorToString;
exports.colorToName = colorToName;
exports.allColors = allColors;
exports.id = id;
exports.name = name;
exports.color = color;
exports.description = description;
exports.priority = priority;
exports.emptyState = emptyState;
exports.setName = setName;
exports.setDescription = setDescription;
exports.setPriority = setPriority;
exports.setColor = setColor;
exports.fromJson = fromJson;
exports.encode = encode;
/* No side effect */
